/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  return true
  // eslint-disable-next-line
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/* 电话号码 */
export function isvalidPhone(str) {
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  const ret = reg.test(str)
  return ret
}

/* 验证手机号码 */
export function checkPhone(rule, value, callback) {
  if (isvalidPhone(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的手机号'))
  }
}

// { validator(rule, value, callback, source, options) {
//   var errors = []
//   if (!/^([A-Z0-9挂学警港澳]{6}|[A-Z0-9]{7})$/.test(value)) {
//     callback('请输入合法的车牌号')
//   }
//   callback(errors)
// } }

/* 车牌号码 */
export function isvalidCarCode(str) {
  const reg = /^([A-Z0-9挂学警港澳使]{6}|[A-Z0-9]{7})$/
  // const reg = /^([A-Z0-9\u4e00-\u9fa5]{6}|[A-Z0-9\u4e00-\u9fa5]{7}$
  const ret = reg.test(str.trim())
  return ret
}

/* 验证车牌号码 */
export function checkCarCode(rule, value, callback) {
  if (isvalidCarCode(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的车牌号码'))
  }
}

/* 邮箱 */
export function isvalidEmail(str) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  const ret = reg.test(str.trim())
  return ret
}

